import { inject, Injectable } from '@angular/core';

import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { merge } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { filterDefined } from '@core/common-legacy';
import { SubscriptionPricingActions, SubscriptionPricingSelectors } from '@recruitee/billing-data';

@Injectable({ providedIn: 'root' })
export class SubscriptionDataService {
  private readonly store = inject(Store);
  private readonly actions$ = inject(Actions);

  public readonly data$ = this.store
    .select(SubscriptionPricingSelectors.data)
    .pipe(filterDefined, shareReplay({ bufferSize: 1, refCount: true }));

  public readonly errors$ = merge(
    this.actions$.pipe(
      ofType(
        SubscriptionPricingActions.paymentIntentFailure,
        SubscriptionPricingActions.changePlanFailure,
      ),
    ),
    this.actions$.pipe(
      ofType(
        SubscriptionPricingActions.patchSubscriptionFailure,
        SubscriptionPricingActions.paymentIntentStripeFailure,
        SubscriptionPricingActions.addCardFailure,
      ),
      map(({ payload }) => payload.error),
    ),
  ).pipe(shareReplay({ bufferSize: 1, refCount: true }));

  public isSubscriptionScheduledForCancellation$ = this.data$.pipe(
    map(subscription => {
      const cancelledStatuses = new Set([
        'non_renewing',
        'blocked',
        'future',
        'inactive',
        'trialing',
      ]);
      return (
        cancelledStatuses.has(subscription.status) ||
        subscription.contractTerm?.actionAtTermEnd === 'cancel'
      );
    }),
  );

  public fetch() {
    this.store.dispatch(SubscriptionPricingActions.fetch());
  }
}
